import { render } from "./AreaDeliveryCost.vue?vue&type=template&id=23d49d32&ts=true&lang=pug"
import script from "./AreaDeliveryCost.vue?vue&type=script&lang=ts"
export * from "./AreaDeliveryCost.vue?vue&type=script&lang=ts"

import "./AreaDeliveryCost.vue?vue&type=style&index=0&id=23d49d32&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__